export enum OrderStatus {
  Open = 0,
  Cancelled = 1,
  Preparing = 2,
  Served = 3,
  Completed = 4,
}
